import { LiveStatsBuilder } from '../live-stats/live-stats.builder';
import { CompletedCallsStatsBuilder } from '../shift-stats/shift-stats.builder';
var QueueStatsBuilder = /** @class */ (function () {
    function QueueStatsBuilder() {
        this.queueStats = {
            queueId: 'b00b0b0b-b0b00b0b-0b0b0b0b0-0b0b0b0',
            queueName: 'bob queue',
            queueLocale: 'en',
            completedStats: new CompletedCallsStatsBuilder().build(),
            liveStats: new LiveStatsBuilder().build(),
            blockManualCallTransfer: false
        };
    }
    QueueStatsBuilder.prototype.withId = function (queueId) {
        this.queueStats.queueId = queueId;
        return this;
    };
    QueueStatsBuilder.prototype.withName = function (name) {
        this.queueStats.queueName = name;
        return this;
    };
    QueueStatsBuilder.prototype.withLocale = function (locale) {
        this.queueStats.queueLocale = locale;
        return this;
    };
    QueueStatsBuilder.prototype.withCompletedStats = function (completedStats) {
        this.queueStats.completedStats = completedStats;
        return this;
    };
    QueueStatsBuilder.prototype.withLiveStats = function (liveStats) {
        this.queueStats.liveStats = liveStats;
        return this;
    };
    QueueStatsBuilder.prototype.build = function () {
        return this.queueStats;
    };
    return QueueStatsBuilder;
}());
export { QueueStatsBuilder };
//# sourceMappingURL=queue-stats.builder.js.map